interface IRequestBiometricPermissionOptions {
  onGrantedCb: () => void;
  onErrorCb: (error: unknown) => void;
}

/**
 * This uses the browser navigator media devices to request access to the camera.
 */
export const requestBiometricPermission = async ({
  onGrantedCb,
  onErrorCb,
}: IRequestBiometricPermissionOptions) => {
  try {
    const auth = !window.PublicKeyCredential;

    if (auth) {
      onErrorCb('Finger print not available ');
    } else {
      onGrantedCb();
    }
  } catch (error) {
    onErrorCb(error);
  }
};
